import { useModals } from "ModalProvider";
import CatalogFormModal from "./CatalogFormModal";

const CatalogCard = ({ cat, refetch }) => {
  const modal = useModals();

  const handleEditCatalog = () => {
    modal.present({
      maxWidth: "max-w-3xl",
      center: true,
      children: (
        <CatalogFormModal cat={cat} refetch={refetch} hide={modal.hide} />
      ),
    });
  };

  return (
    <div
      className={`group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2 cursor-pointer ${
        cat.isActive ? "" : "opacity-30"
      }`}
      onClick={handleEditCatalog}
    >
      <div className="relative overflow-hidden">
        <div className="_df_button bg-none p-0 w-full" source={cat.pdf}>
          <img
            className="w-full h-80 object-cover transition-transform duration-300 group-hover:scale-105"
            src={cat.poster}
            alt={cat.name}
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        {/* Status Badge */}
        <div className="absolute top-4 right-4">
          <span
            className={`px-3 py-1 rounded-full text-xs font-semibold backdrop-blur-sm ${
              cat.status === "new"
                ? "bg-green-500/90 text-white"
                : "bg-gray-500/90 text-white"
            }`}
          >
            {cat.status}
          </span>
        </div>
      </div>

      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 text-center line-clamp-2">
          {cat.name}
        </h3>
      </div>
    </div>
  );
};

export default CatalogCard;
